import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomValidator } from '@shared/services/custom-validatior.abstract';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CouponResponse } from '@core/models/promo-code.modal';
import { MessageService } from 'primeng/api';
import { BookingFlowService } from '../service/booking-flow.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-booking-offers-list-modal',
  templateUrl: './booking-offers-list-modal.component.html',
  styleUrls: ['./booking-offers-list-modal.component.scss']
})
export class BookingOffersListModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  bookingId: string;
  availableOffers: any | null;
  errorMessage: string;
  userCredit: boolean = false;
  userOffer: any;
  showCouponError: boolean = false;
  afterApplyOffer: any;
  isOfferChange:boolean = false
  CheckCouponValidityForm: FormGroup;
  couponValidity: CouponResponse;
  prefereedPaymentMethodId:string = '';
  isPrefereedPaymentMethod:boolean = false;
  paymentMethod;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly bookingFlowService: BookingFlowService,
    private readonly config: DynamicDialogConfig,
    private readonly formBuilder: FormBuilder,
    private readonly messageService: MessageService,
  ) { }

  ngOnInit() {
    this.bookingId = this.config?.data?.bookingId;
    this.userCredit = this.config.data.userCredit;  
    this.paymentMethod = this.config.data?.paymentMethod;  
    this.prefereedPaymentMethodId = this.config.data?.prefereedPaymentMethodId;
    this.isPrefereedPaymentMethod = this.config.data?.isPrefereedPaymentMethod;
    this.GetOfferByBookingId()
    this.CheckCouponValidityForm = this.formBuilder.group({
      couponCode: ['',Validators.required]
    });
  }

  closeDialog() {
    this.ref.close();
  }

  GetOfferByBookingId() {
    let bookingIddata = {
      bookingId: this.bookingId
    }
    this.bookingFlowService.getOfferList(bookingIddata)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (res: any) => {
        if (res) {
          
          this.availableOffers = res;
          
        }

      },
      error: (error => {
        if (error) {
          
          this.errorMessage = error.error.message;
        }
      })
    })

  }

  checkCouponValidity(){
    this.showCouponError = true; 
    if (this.CheckCouponValidityForm.valid) {
      
      this.bookingFlowService.checkCouponValidityWithBookingId(this.CheckCouponValidityForm.value.couponCode, this.bookingId)
      .pipe(autoUnsubWith(this.destroyRef))
        .subscribe({
          next: (res:CouponResponse) => {   
            this.couponValidity = res;
            this.applyOffer(res)
            
          },
          error: (err) => {
            if(err.error){  
              
              this.messageService.add({
                severity:"error",
                summary:"Error",
                detail:err.error['message']
              });
            }
          }
        });
    }else {
      CustomValidator.markFormGroupTouched(this.CheckCouponValidityForm);
      
    }
  }

  UpdateBookingByOffer(offerId: string,redeemStatus:number) {
    let data = {
      bookingId: this.bookingId,
      useCredit: this.userCredit,
      useOffer: {
        offerId: offerId,
        isRedeemed: redeemStatus,
        isOfferChange: (this.isOfferChange ===true) ? false:true,
      },
      paymentMethod: this.paymentMethod,
      prefereedPaymentMethodId: this.prefereedPaymentMethodId,
      isPrefereedPaymentMethod: this.isPrefereedPaymentMethod,
      isExemptTaxesAndFees: this.config.data?.isExemptTaxesAndFees,
    };
  
    this.bookingFlowService.UpdateBookingByOffer(data)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (res: any) => {
        this.afterApplyOffer = res;
        this.ref.close({ offer: this.availableOffers, afterApplyOffer: this.afterApplyOffer,useOffer:data.useOffer,credits : this.afterApplyOffer?.usedCredit });
      }
    });
  }

  applyOffer(offer: any) {
    this.isOfferChange = true
    this.UpdateBookingByOffer(offer.offerId,offer.redeemStatus);
  }
}